module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2f"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "prologue"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Prologue")])])]), _c('a', {
    attrs: {
      "id": "prologue"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("Tuscany, 1966")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("The little girl stood outside the imposing black gates of Villa La Magdalena and peered up the drive. A long avenue of cypresses cut straight through the grounds, climaxing at the end in a tantalizing glimpse of a primrose-yellow palazzo. La Magdalena sat with the dignity and poise of a grand empress. Her tall, shuttered windows were an elegant teal green, her crown a decorative balustrade built along the top of the facade, her walls as resplendent as silk; she belonged to a world as enchanting and inaccessible as fairy tales.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The bright Tuscan sun threw inky shadows across the drive, and the little girl could smell the sweet scents of the garden that rose in the midday heat and saturated the air. She stood in her sandals and grubby sundress, her long brown hair matted with dust and seawater, hanging down her back and over eyes that were dark and troubled and full of craving. Around her neck she wore a Virgin Mary pendant her mother had given her before running off with a man she had met over the tomato stall in Piazza Laconda, taking her younger brother with them.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prologue"
    }
  }, [_vm._v("The little girl came to La Magdalena often. She liked to climb the wall where a part of it had crumbled, leaving it low enough for her to scale. She’d sit on the top and survey the beautiful gardens of stone fountains, graceful umbrella pines, and marble statues of elegant ladies and seminaked men twisted into theatrical poses of love and longing. She liked to imagine that "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("she")]), _vm._v(" lived there surrounded by such heavenly splendor—a young lady with expensive dresses and sparkly shoes, cherished by a mother who threaded her hair with ribbons, and a father who indulged her with presents and tossed her into the air before catching her in his strong, protective arms; she came to La Magdalena ")]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("to forget her own drunken father and the little apartment on Via Roma that she struggled to keep clean.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Her small hands gripped the bars and she squeezed her face between them to get a better look at the boy who was now walking towards her, accompanied by a mongrel dog. She knew he was going to tell her to go away, so she wanted to get a good look first, before running back down the path that snaked its way to the beach.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The boy was handsome, much older than she, with fair hair brushed off his forehead and a kind face. He appraised her with pale, smiling eyes, and on closer inspection she could see that they were green. She stood her ground, daring herself to remain until the very last moment. Her fingers curled around the bars and she clenched her jaw in determination, but his grin disarmed her; it didn’t look like the expression of a person about to shoo her away. He put his hands in his pockets and examined her through the gate.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hello there.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She said nothing. Her head told her to flee, but her legs wouldn’t listen. She remained staring at him, unable to tear her eyes away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you want to come in?” His invitation caught her off guard, and she straightened up suspiciously. “You’re obviously curious.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was just passing,” she replied.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So you "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("can")]), _vm._v(" speak.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course I can speak.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I wasn’t sure at first. You looked so frightened.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not frightened of you, if that’s what you mean.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Good.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was just on my way somewhere.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s funny, we’re rather isolated here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know that. I was on the beach.” Which was true, at least.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So you just wandered up to have a look?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s so pretty. It caught my attention.” Her face brightened as she mentioned the villa, and her eyes strayed longingly up the drive.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then come in and I’ll show you around the gardens. My family isn’t here so I’m alone. It’ll be nice to have someone to talk to.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know …” Her eyes darkened again, but he opened the gate.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t be afraid. I’m not going to hurt you.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("“I’m not afraid,” she retorted. “I can look after myself, you know.”")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sure you can.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She stepped in, and he closed the gate behind her. She watched him lock it, and her heart lurched a moment with anxiety; but then her gaze was drawn back to the villa, and she forgot her fear. “Do you live here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not all the time. I live in Milan mostly, but we summer here every year.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then I will have seen you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Really?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her excitement at being in the grounds gave her courage. “Yes, I spy from the wall.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You little devil.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I like to look at the gardens. The people don’t interest me so much.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then I’ll give you a better look so you won’t have to spy anymore.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She walked beside him, her heart now swelling with pleasure. “Is all this really yours?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, my father’s.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If this is your summer house, your house in Milan must be built for a king.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He laughed, tossing back his head. “It’s big, but not big enough for a king. This is bigger. There’s more space in the countryside.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s old, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Fifteenth century. It was built by the Medici family, designed by Leon Battista Alberti in 1452. Do you know who he was?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course I do.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How old are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ten and ten months. My birthday’s in August. I suppose I’ll have a big party.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sure you will.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She looked down at her feet. She had never had a party. Now her mother had gone, no one would even remember her birthday. “What’s your dog called?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Good-Night.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s a funny name.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("“He was a stray I found on the road in the middle of the night. We ")]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("bonded immediately, so I called him Good-Night, because it was a good night, finding him.”")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("She bent down to stroke him. “What is he?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know. A mixture of lots of different breeds.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’s sweet.” She giggled as the dog licked her face. “Whoa, steady there, doggie!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He likes you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know. Stray animals always like me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Because you look like a stray yourself")]), _vm._v(", he thought, watching her wrap her arms around Good-Night’s neck and rest her head against his fur.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve made a friend,” she said with a triumphant smile.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He laughed at her exuberance. “No, you’ve made two. Come on.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They walked the full length of the drive side by side, her confidence growing with each step. He explained the architecture, showing off his knowledge, and she listened, enraptured by every detail, trying to remember in order to later tell her friend, Costanza. The villa was even bigger than she had thought. She had seen only the central part between the trees at the end of the avenue. It had two other wings not quite as tall as the bit in the middle but just as wide. Classically proportioned and unfussy, it had an understated grandeur, the yellow paint giving it a happy, complacent look, as if it knew it didn’t have to try at being beautiful. She longed to go inside, to walk through the rooms and gaze at the paintings that hung on the walls. She was sure it was even more wonderful than the outside. But he took her round to the back, where a sweeping stone staircase descended from the villa into a formal garden of statues, terra-cotta pots of topiary, and lofty pines. It was as though she had died and now walked through paradise, for surely only Heaven could be as beautiful as this?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He directed her through a small gate in the wall, into a pretty ornamental garden settled within a circular stone colonnade. The centerpiece was a glorious fountain of mermaids throwing water into the air. Around the fountain a path was planted haphazardly with thyme, and pretty iron benches were set on all four sides against low hedges that boxed four neatly trimmed lawns and flower beds. She took a while to take it all in, standing there in her sandals, clutching her heart because she had never before seen so much splendor.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("“This is my mother’s garden,” he told her. “She wanted a place where she could read in private without being spied on.” He winked at her and laughed again. “You’d have to be a very accomplished spy to get in here.”")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I bet your mother’s pretty,” she said, thinking of her own mother and trying to remember what she looked like.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She is, I suppose. One doesn’t really think of one’s mother in that way.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Where does she read?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think she probably sits on one of these benches, by the fountain. I don’t know. I’ve never bothered to notice.” He ambled over, suddenly infected with the little girl’s awe. “It "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("is")]), _vm._v(" rather lovely, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Imagine sitting here in the sunshine, listening to the trickling water and watching the birds washing themselves in it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s very peaceful.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I love birds. I bet you have many birds here. Different ones, probably, from those we have in town.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He laughed incredulously. “I think you’ll find the same old birds as the ones you have in Herba.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, you’ll have special ones in here.” She was so certain, he looked around, half expecting to see parrots in the pine trees. “Do you ever sit here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why not?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He shrugged. “What would I do?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, there’s plenty to look at. I could sit in here for hours—days even. I could sit in here forever and never want to leave.” She carefully lowered herself onto the bench as if it were a sacred thing she was afraid might break. Once sitting, she watched the water and imagined having a garden of her own where she could enjoy the changing light from dawn till dusk. “God is in here,” she said softly, feeling a strange sense of wonder creep over her skin, like the warm breath of an angel.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He sat beside her and stretched out his legs, putting his hands behind his head. “Do you think?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, I know. I can feel Him.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("They sat there a long time, listening to the breeze in the cypress trees ")]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("and the doves contentedly cooing on the roof of the villa. Good-Night sniffed the borders, cocking his leg against the hedge.")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“This is the best day of my life,” she said after a while. “I don’t think I’ve ever been so happy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He looked at her curiously, a tender smile curling his lips. “What’s your name, "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("piccolina")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She looked back at him, her eyes full of gratitude and trust. “Floriana,” she replied. “And you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Somehow, they both knew that exchanging names "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("meant")]), _vm._v(" something. He hesitated, staring into her gaze, which was now open and no longer afraid. He held out his hand. Tentatively, she took it. Hers looked small and dark in his big pale one.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Dante Alberto Massimo,” he said softly. “But you can call me Dante.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33bfd489","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/prologue.vue
// module id = 75
// module chunks = 0